import { render, staticRenderFns } from "./TemplatesHelp.vue?vue&type=template&id=faf3e08c&scoped=true"
import script from "./TemplatesHelp.vue?vue&type=script&lang=js"
export * from "./TemplatesHelp.vue?vue&type=script&lang=js"
import style0 from "./TemplatesHelp.vue?vue&type=style&index=0&id=faf3e08c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf3e08c",
  null
  
)

export default component.exports